module.exports = __webpack_public_path__ + "static/media/signage-industrial-img13.94e67852.jpg";